/**
 * What this change was, in the panel's own voice.
 *
 * Deliberately not the record. Rendering each store's record inline gave every
 * row a different typography and a scrollbar, and buried the one new fact in
 * everything Phoebe already held. The row says what changed; Open shows the
 * record it changed.
 *
 * Shown in full: one change is a sentence or two, so clamping it only ever
 * hides the end of a thought — the length problem belonged to the records,
 * which are now behind Open.
 */
export function RecordPreview({ text }: { readonly text: string }) {
    return (
        <p className="border-border/50 bg-muted/25 text-foreground/85 w-full rounded-md border px-2.5 py-2 text-[11px] leading-4">
            {text}
        </p>
    );
}
